import { closeVehicleConfigurator } from '../../_flux/actions/vehicle_configurator_actions';
import { updateFilterOptionsAction } from '../../_flux/actions/filter_options_actions';
import CatalogTyreFilterStore from '../../_flux/stores/catalog_filter_store/tyre';
import CatalogConfiguratorStore from '../../_flux/stores/catalog_configurator_store';
import { Filters } from '../../_flux/constants/filter/filters';
import { getDefaultValueForFilter } from '../../_flux/helper/filters/get_default_value_for_filter';
import { showTyreIndexAction } from '../../_flux/actions/catalog_configurator_actions';
import {pickBy} from '../../../lib/utilities';

export function onConfiguratorClose() {
    closeVehicleConfigurator();

    const filterState = CatalogTyreFilterStore.getState();
    if (filterState.width === '') {
        updateFilterOptionsAction(
            pickBy(
                TYROOLA.initialFluxStates?.filter?.filterOptions,
                (filterValue, filterName) => [Filters.SPEED_INDEX, Filters.LOAD_INDEX].indexOf(filterName) !== -1
            )
        );
    }

    const configuratorState = CatalogConfiguratorStore.getState();
    const currentDiameter = filterState[Filters.DIAMETER];
    const diameterDefaultValue = getDefaultValueForFilter(Filters.DIAMETER);

    if (!configuratorState.tyreIndexVisible && currentDiameter === diameterDefaultValue) {
        showTyreIndexAction();
    }
}
